import React, { useEffect, useState } from 'react';
import { Form, Input } from 'antd';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { FormItem } from 'component/form_component/style';
import { useDispatch } from 'react-redux';
import { createRandomApikey, getGenerateApikeys, getRandomApikey } from 'redux/slices/apiSettings';
import { SweetSweetAlert } from 'component/sweetalert_components';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';

const CreateApi = ({ setModal }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);
  const [disable, setDisable] = useState(true);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    const handleGeneratePassword = async () => {
      setloading(true);
      const generateApikeys = await dispatch(getGenerateApikeys());
      if (generateApikeys?.payload) {
        form.setFieldsValue({ apiKey: generateApikeys.payload.key1, apiSecret: generateApikeys.payload.key2 });
        setDisable(false);
      }
      setloading(false);
    };
    handleGeneratePassword();
  }, []);

  const handleCopyClick = () => {
    const combinedText = `API Key: ${form.getFieldValue('apiKey')}, API Secret: ${form.getFieldValue('apiSecret')}`;
    navigator.clipboard.writeText(combinedText).then(() => setCopied(true));
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const onFinish = async (values) => {
    try {
      setloading(true);
      const response = await dispatch(createRandomApikey(values));
      if (response?.payload.status === 200) {
        await SweetSweetAlert({ sweetData: response.payload.data, icon: 'success', buttonColor: 'green' });
        setModal(false);
        dispatch(getRandomApikey());
      } else if (response?.payload.status === 400) {
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'error', buttonColor: 'red' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      return error;
    } finally {
      setloading(false);
    }
  };

  return (
    <div className='af-modal-wrap af-modal-wrap-apiKeys'>
      {loading && <ModalOpenLoader />}
      <h2 className='af-form-header af-add_apiKeys-form-header'>New API Keys</h2>
      <Form
        form={form}
        className='af-form af-add_apiKeys-form'
        size='large'
        layout='vertical'
        name='apikeys'
        onFinish={onFinish}
        initialValues={{}}
      >
        <FormItem
          className='formItemEvenLine af-form-item af-add_apiKeys-form-item af-add_apiKeys-form-item-name'
          name='name'
          label='Name:'
          rules={[
            {
              required: true,
              message: 'Please Enter this Field',
            },
          ]}
        >
          <Input
            placeholder='Name - Something for your reference'
            className='af-form-input af-add_apiKeys-form-input af-add_apiKeys-form-input_name'
          />
        </FormItem>
        <FormItem
          name='apiKey'
          className='af-form-item af-add_apiKeys-form-item af-add_apiKeys-form-item-apikey1'
          label='API Key:'
          rules={[
            {
              required: true,
              message: 'Please Enter this Field',
            },
          ]}
        >
          <Input
            disabled={true}
            onContextMenu={(e) => e.preventDefault()}
            onCopy={(e) => e.preventDefault()}
            onDragStart={(e) => e.preventDefault()}
            className='af-form-input af-add_apiKeys-form-input af-add_apiKeys-form-input_apikey1 no-copy-input'
          />
        </FormItem>
        <FormItem
          name='apiSecret'
          className='af-form-item af-add_apiKeys-form-item af-add_apiKeys-form-item-apikey2'
          label='API Secret:'
          rules={[
            {
              required: true,
              message: 'Please Enter this Field',
            },
          ]}
        >
          <Input
            disabled={true}
            onContextMenu={(e) => e.preventDefault()}
            onCopy={(e) => e.preventDefault()}
            onDragStart={(e) => e.preventDefault()}
            className='af-form-input af-add_apiKeys-form-input af-add_apiKeys-form-input_apikey2 no-copy-input'
          />
        </FormItem>
        <FormItem
          className='af-form-button-submit-wrapper af-add_apiKeys-form-button-submit-wrapper'
          style={{ textAlign: 'end' }}
        >
          <StyledButton
            disabled={disable}
            type='primary'
            className='af-form-button af-add_apiKeys-form-button af-add_apiKeys-form-button_submit'
            onClick={handleCopyClick}
          >
            {copied ? 'Copied' : 'Copy Keys'}
          </StyledButton>
          <StyledButton
            type='primary'
            htmlType='submit'
            className='af-form-button af-add_apiKeys-form-button af-add_apiKeys-form-button_submit'
          >
            Submit
          </StyledButton>
        </FormItem>
      </Form>
    </div>
  );
};

export default CreateApi;
